import axios from 'axios';
import { SET_CURRENT_ROUTE, SET_SIDE_BAR_OPEN,AUTH_USER, UNAUTH_USER,AUTH_ERROR } from './types';
import { newUrl } from '../../utility';

export const  setAuthTokenAction = (token,user)=> dispatch => {
    console.log('token',token)
    axios.defaults.headers.common['authorization'] = token
    localStorage.setItem("plano_token", token);
    localStorage.setItem("user",user.email);
}

export const signInUser = ({email,password}) => dispatch => {
    
    axios.post(`${newUrl}/signin`, {email,password})
        .then(response => {
            console.log(response);
            setAuthTokenAction(response.data.token,response.data.user)(dispatch);
            dispatch({ type: AUTH_USER, payload:response.data.user });
           
         })
        .catch(error => {
            console.log('errgfgdg',error)
            authError(error)(dispatch);
        });
}

export const authError = (error) => dispatch => {
	dispatch({
		type: AUTH_ERROR,
		payload: error
	});
}

export const setCurrentRoute = (routeName) => dispatch => {
    dispatch({
        type : SET_CURRENT_ROUTE,
        payload : routeName
    })

    dispatch({
        type: SET_SIDE_BAR_OPEN,
        payload: false
    })
}

export const toggleSiderBarOpen = (sideBarOpen) => dispatch => {
    dispatch({
        type: SET_SIDE_BAR_OPEN,
        payload : sideBarOpen
    })
}




// WEBPACK FOOTER //
// ./src/v3/actions/authActions.js